<template>
  <div class="bill-statement">
    <div class="nav">
      <el-form :model="form" label-width="100px" :inline="true"  class="demo-form-inline flex1">
        <el-form-item label="对账单编号:">
          <el-input v-model="form.batch" size="mini" placeholder="请输入对账单编号"></el-input>
        </el-form-item>
        <el-form-item label="对账单标题:">
          <el-input v-model="form.Waybill" size="mini" placeholder="请输入对账标题"></el-input>
        </el-form-item>
        <el-form-item label="生成时间:">
          <el-select v-model="form.transport" filterable size="mini" placeholder="请选择对账单生成时间">
            <el-option v-for="(item,index) in createTimeList" :label="item.tiem" :value="item.id" :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态:">
          <el-select v-model="form.transport" filterable size="mini" placeholder="请选择对账单生成时间">
            <el-option label="全部" value=""></el-option>
            <el-option label="待审核" value="1"></el-option>
            <el-option label="已通过" value="2"></el-option>
            <el-option label="待提交审核" value="3"></el-option>
            <el-option label="未通过" value="-1"></el-option>
          </el-select>
        </el-form-item>


        <el-form-item>
          <el-button size="small" class="searchBtn" @click="searchBtn">查询</el-button>
          <el-button size="small" class="resetBtn" @click="resetBtn">重置</el-button>
        </el-form-item>

      </el-form>
    </div>

    <div class="content">
      <div class="tableContainer">
        <el-table
          v-loading="tableLoad"
          :data="TableDatas"
          style="width: 100%"
          border
           :header-cell-style="{color:'#3B3B3B','font-size':'13px','height':'48px',background:'#E8E8E8'}"
        >
          <el-table-column label="序号" align="center" width="50px">
            <div slot-scope="scope">{{scope.$index+1}}</div>
          </el-table-column>
          <el-table-column prop="batch" label="对账单编号" align="center"/>
          <el-table-column prop="Waybill" label="标题" align="center"/>
          <el-table-column prop="planDate" label="生成时间" align="center"/>
          <el-table-column prop="referred" label="含税费用" align="center"/>
          <el-table-column prop="referred" label="税后费用" align="center"/>
          <el-table-column prop="whetherBill" label="状态" align="center"/>
          <el-table-column  label="状态" align="center">
            <template slot-scope="scope">
              <div>
                <el-button size="mini" class="searchBtn" @click="checkButton(scope.$index,scope.row)">核对对账单</el-button>
                <el-button size="mini" class="searchBtn" @click="detailButton(scope.row.id)">详情</el-button>
                <el-button size="small" type="primary" @click="SubmitButton(scope.row.id)">提交审核</el-button>
                <el-button size="small" type="info" @click="cancelButton(scope.row.id)">取消审核</el-button>
                <el-button size="small" type="danger" @click="deleteButton(scope.row.id)">删除</el-button>
              </div>
            </template>

          </el-table-column>
        </el-table>
      </div>
      <div class="paginationContainer">
        <el-pagination
          background
          :page-sizes="[10, 20, 30, 40]"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="contractSizeChange"
          @current-change="contractCurrentChange"
          :current-page.sync="form.page"
          :page-size="form.rows"
        />
      </div>
    </div>

    <el-dialog title="生成对账单" :visible.sync="importShow" width='1250px' center>
      <div class="importBill">
        <div class="baseInfo">
          <div class="baseInfoContent">
            <div style="display: flex;align-items: center;margin-bottom: 10px">
              <div style="font-weight: 700;">上传时间：</div>
              <div>2021-10-19 13:50:44</div>
              <div style="margin-left: 20px" class="exportButton">
                <span >导入生成对账单</span>
                <span>导出数据</span>
              </div>

            </div>
            <el-row style="margin-bottom: 10px">
              <el-col :span="24" style="font-size: 14px;color: #606266;font-weight: 700;">合计含税费用:</el-col>
            </el-row>
            <el-row style="margin-bottom: 10px">
              <el-col :span="24" style="font-size: 14px;color: #606266;font-weight: 700;">合计税后费用:</el-col>
            </el-row>

            <el-table
              v-loading="checkLoad"
              :data="checkTableData2"
              style="width: 100%"
              border
              :header-cell-style="{background:'#E8E8E8',color:'#3B3B3B'}"
              :row-class-name="tableRowClassName"
            >
              <!--              <el-table-column label="序号" align="center" width="50px">-->
              <!--                <div slot-scope="scope">{{scope.$index+1}}</div>-->
              <!--              </el-table-column>-->
              <el-table-column prop="batch" label="批次号" align="center"/>
              <el-table-column prop="Waybill" label="运单编号" align="center"/>
              <el-table-column prop="chassis" label="底盘号" align="center"/>
              <el-table-column prop="brand" label="品牌" align="center"/>
              <el-table-column prop="model" label="型号" align="center"/>
              <el-table-column prop="consignor" label="委托商" align="center"/>
              <el-table-column prop="distributor" label="经销商" align="center"/>
              <el-table-column prop="planDate" label="计划日期" align="center"/>
              <el-table-column prop="referred" label="发运日期" align="center"/>
              <el-table-column prop="referred" label="交车日期" align="center"/>
              <el-table-column prop="transport" label="运输条款" align="center"/>
              <el-table-column prop="included" label="含税费用" align="center" />
              <el-table-column prop="afterTax" label="税后费用" align="center" />
              <el-table-column prop="remark" label="说明" align="center" />
              <el-table-column  label="操作" align="center" width="150px">
                <template slot-scope="scope">
                  <el-button size="mini" type="primary">修改金额</el-button>
                  <el-button size="mini" type="danger" @click="deleteClick(scope.$index)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>



        </div>
        <div class="operation">
          <div class="operationTitle">
            <div class="line"/>
            <span>未找到车辆</span>
          </div>
          <div class="operationTable">
            <el-table
              v-loading="checkLoad"
              :data="notTableData"
              style="width: 100%"
              border
              :header-cell-style="{background:'#E8E8E8',color:'#3B3B3B'}"
            >
              <el-table-column label="序号" align="center" width="50px">
                <div slot-scope="scope">{{scope.$index+1}}</div>
              </el-table-column>
              <el-table-column prop="batch" label="批次号" align="center"/>
              <!--              <el-table-column prop="Waybill" label="运单编号" align="center"/>-->
              <el-table-column prop="chassis" label="底盘号" align="center"/>
              <el-table-column prop="brand" label="品牌" align="center"/>
              <el-table-column prop="model" label="型号" align="center"/>
              <!--              <el-table-column prop="consignor" label="委托商" align="center"/>-->
              <!--              <el-table-column prop="distributor" label="经销商" align="center"/>-->
              <!--              <el-table-column prop="planDate" label="计划日期" align="center"/>-->
              <!--              <el-table-column prop="referred" label="发运日期" align="center"/>-->
              <!--              <el-table-column prop="referred" label="交车日期" align="center"/>-->
              <el-table-column prop="transport" label="运输条款" align="center"/>
              <el-table-column prop="included" label="含税费用" align="center" />
              <el-table-column prop="afterTax" label="税后费用" align="center" />
              <el-table-column prop="remark" label="说明" align="center" />
              <el-table-column  label="操作" align="center">
                <template slot-scope="scope">
                  <el-button size="mini" type="primary">添加</el-button>
                  <el-button size="mini" type="primary">首页提醒</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>



      </div>

    </el-dialog>

    <el-dialog title="详情" :visible.sync="detaiDialog" width='1190px' center>
      <div class="detail">
        <div class="baseInfo">
          <div class="baseInfoTitle">
            <div class="line"/>
            <span>基础信息</span>
          </div>
          <div class="baseInfoContent">
            <el-form :model="detailData"  label-position="left" style=" width: 708px;">
              <el-row>
                <el-col :span="24">
                  <el-form-item label="对账单编号:">
                    <span>{{detailData.number}}</span>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item label="标题:">
                    <span>{{detailData.number}}</span>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="运输条款:">
                    <span>{{detailData.number}}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="生成时间:">
                    <span>{{detailData.number}}</span>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="含税费用:">
                    <span>{{detailData.number}}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="税后费用:">
                    <span>{{detailData.number}}</span>
                  </el-form-item>
                </el-col>
              </el-row>

            </el-form>
          </div>
          <div class="operation">
            <div class="operationTitle">
              <div class="line"/>
              <span>车辆费用</span>
            </div>
            <div class="operationTable">
              <div class="operationTableNav">
                <span>导出费用</span>
              </div>
              <el-table
                v-loading="checkLoad"
                :data="carTableData"
                style="width: 100%"
                border
                :header-cell-style="{background:'#E8E8E8',color:'#3B3B3B'}"
              >
                <el-table-column label="序号" align="center" width="50px">
                  <div slot-scope="scope">{{scope.$index+1}}</div>
                </el-table-column>
                <el-table-column prop="batch" label="供应商" align="center"/>
                <el-table-column prop="Waybill" label="运单编号" align="center"/>
                <el-table-column prop="batch" label="批次号" align="center"/>
                <el-table-column prop="chassis" label="底盘号" align="center"/>
                <el-table-column prop="brand" label="品牌" align="center"/>
                <el-table-column prop="model" label="型号" align="center"/>
                <el-table-column prop="consignor" label="委托商" align="center"/>
                <el-table-column prop="distributor" label="经销商" align="center"/>
                <el-table-column prop="referred" label="发运日期" align="center"/>
                <el-table-column prop="referred" label="交车日期" align="center"/>
                <el-table-column prop="transport" label="起始城市" align="center"/>
                <el-table-column prop="transport" label="目的城市" align="center"/>
                <el-table-column prop="included" label="含税费用" align="center" />
                <el-table-column prop="afterTax" label="税后费用" align="center" />
              </el-table>
            </div>
          </div>

          <div class="operation" v-if="false">
            <div class="operationTitle">
              <div class="line"/>
              <span>其它费用</span>
            </div>
            <div class="operationTable">
              <el-table
                v-loading="checkLoad"
                :data="otherTableData"
                style="width: 50%"
                border
                :header-cell-style="{background:'#E8E8E8',color:'#3B3B3B'}"
              >
                <el-table-column label="序号" align="center" width="50px">
                  <div slot-scope="scope">{{scope.$index+1}}</div>
                </el-table-column>
                <el-table-column prop="supplier" label="供应商" align="center"/>
                <el-table-column prop="costType" label="费用类型" align="center"/>
                <el-table-column prop="remark" label="费用说明" align="center"/>
                <el-table-column prop="time" label="费用时间" align="center" />
                <el-table-column prop="money" label="费用金额" align="center" />
              </el-table>
            </div>
          </div>
          <div class="operation">
            <div class="operationTitle">
              <div class="line"/>
              <span>审核信息</span>
            </div>
            <div class="operationTable">
              <steps :step-data="stepData" :step-state="stepState" style="width: 60%"/>
            </div>
          </div>
          <div class="operation">
            <div class="operationTitle">
              <div class="line"/>
              <span>操作记录</span>
            </div>
            <div class="operationTable">
              <el-table :data="operationData" border :header-cell-style="{background:'#E8E8E8',color:'#3B3B3B'}" style="width: 50%">
                <el-table-column prop="operateTime" label="操作时间" align="center" width="160px"/>
                <el-table-column prop="operateType" label="操作类型" align="center"/>
                <el-table-column prop="account" label="操作人" align="center"/>
                <el-table-column prop="remark" label="备注" align="center"/>
              </el-table>
            </div>
          </div>
        </div>

      </div>

    </el-dialog>

    <!--    <div class="operation">-->
    <!--      <div class="operationTitle">-->
    <!--        <div class="line"/>-->
    <!--        <span>审核信息</span>-->
    <!--      </div>-->
    <!--      <div class="operationTable">-->
    <!--        <steps :step-data="stepData" :step-state="stepState"/>-->
    <!--      </div>-->
    <!--    </div>-->
  </div>
</template>

<script>
  import {
    baseUrl,
    baseImgUrl
  } from "@/config/env";
  import uploadImg from "@/components/uploadImg";
  import divBorder from "@/components/divBorder";
  import steps from "@/components/steps";
  export default {
    components: {
      uploadImg,
      divBorder,
      steps
    },

    data() {
      return {
        form:{
          batch:"",//批次号
          Waybill:'',//运单编号
          chassis:'',//底盘号
          consignor:'',//委托商
          distributor:'',//经销商
          planDate:'',//计划日期
          transport:'',//运输条款
          whetherBill:'',//是否生成账单
          page:1,
          rows:10,
        },
        total:0,
        tableLoad:false,
        TableDatas:[
          {
            batch:"",//批次号
            Waybill:'',//运单编号
            chassis:'',//底盘号
            consignor:'',//委托商
            distributor:'',//经销商
            planDate:'',//计划日期
            transport:'',//运输条款
            whetherBill:'',//是否生成账单
            brand:'',
            model:''
          },

        ],
        checkList:[],
        billTitle:'',
        checkLoad:false,
        checkTableData2:[
          {
            batch:"4",//批次号
            Waybill:'',//运单编号
            chassis:'对方答复',//底盘号
            consignor:'',//委托商
            distributor:'',//经销商
            planDate:'',//计划日期
            transport:'',//运输条款
            included:'100',//含税
            afterTax:'200',//税后
            remark:'相等',//说明
            brand:'',
            model:''
          },
          {
            batch:"",//批次号
            Waybill:'',//运单编号
            chassis:'',//底盘号
            consignor:'',//委托商
            distributor:'',//经销商
            planDate:'',//计划日期
            transport:'',//运输条款
            included:'300',//含税
            afterTax:'300',//税后
            remark:'价格异常',//说明
            brand:'',
            model:''
          },
        ],
        notTableData:[
          {
            batch:"4",//批次号
            Waybill:'',//运单编号
            chassis:'对方答复',//底盘号
            consignor:'',//委托商
            distributor:'',//经销商
            planDate:'',//计划日期
            transport:'',//运输条款
            included:'100',//含税
            afterTax:'200',//税后
            brand:'',
            model:''
          },
          {
            batch:"",//批次号
            Waybill:'',//运单编号
            chassis:'',//底盘号
            consignor:'',//委托商
            distributor:'',//经销商
            planDate:'',//计划日期
            transport:'',//运输条款
            included:'300',//含税
            afterTax:'300',//税后
            brand:'',
            model:''
          },
        ],
        otherTableData:[
          {
            supplier:'',//供应商
            costType:'',//费用类型
            remark:'',//费用说明
            money:'',//费用金额
            time:'',
          }
        ],
        importShow:false,
        createTime:'',
        createTimeList:[
          {'tiem':'2021-10-8 11:41:28','id':"1111"}
        ],
        detaiDialog:true,
        stepData:[
          {title:'张三发起',time:'2021-9-30 14:09:23',state:'',remark:''},
          {title:'财务部 张三通过',time:'2021-9-30 14:09:23',state:'success',remark:'原因xxxxxx'},
          {title:'技术部 李四拒绝',time:'2021-9-30 14:09:23',state:'failure',remark:'原因xxxxxx'},
          {title:'张三重新发起',time:'2021-9-30 14:09:23',state:'',remark:''},
        ],
        detailData:{
          state:'待审核',number:'1234567',referred:'民生物流1',type:'商务合同',
          company:'重庆什么dfsdfsdfsdfsdfdfsdfsdf公司',price:'12345666',tell:'02358600000',
          mail:'3150000000@qq.com',area:'重庆市-渝北区',address:'重庆市渝北区xxx',name:'张晓辉',
          nameTell:'17700000000',time:'2021-8-31 15:25:53',createMan:'李忘生',

        },
        carTableData:[
          {
            batch:"",//批次号
            Waybill:'',//运单编号
            chassis:'',//底盘号
            consignor:'',//委托商
            distributor:'',//经销商
            planDate:'',//计划日期
            transport:'',//运输条款
            included:'300',//含税
            afterTax:'300',//税后
            brand:'',
            model:''
          },
          ],
        operationData:[
          {operateTime:'2021-8-31 15:49:58',operateType:'启用',account:'王三文',remark:''},
          {operateTime:'2021-8-31 15:49:58',operateType:'禁用',account:'张三丰',remark:''},
          {operateTime:'2021-8-31 15:49:58',operateType:'添加',account:'赵兮雪',remark:''},
        ],
        addflag:false,
        rules:{
          plan:{required: true, message: ' ', trigger: 'blur'},
          name:[
            { required: true, message: '请输入业务名称', trigger: 'blur' },
            { min: 3, max: 9, message: '长度在 3 到 9 个字符', trigger: 'blur' }
          ],
          content:{required: true, message: '请输入评审需求', trigger: 'blur'},
          type: { required: true, message: '请选择评审类型', trigger: 'blur' },
          img:{ required: true, message: '请选择合同照片', trigger: 'blur' },

        }

      };

    },
    computed:{
      stepState(){
        return function(state){
          switch(state) {
            case '':
              return 'wait'
            case 'success':
              return 'success'
            case 'failure':
              return 'error'
          }
        };
      },
      sumIncluded(){

      }
    },
    methods: {
      init(){

      },
      searchBtn(){
        this.form.page = 1
      },
      resetBtn(){
        for (const argumentsKey in this.form) {
          this.form[argumentsKey] = ""
        }
        this.form.page = 1
        this.form.rows = 10

      },
      contractSizeChange(row){
        this.form.rows=row;
      },
      contractCurrentChange(page){
        this.form.page=page;
      },

      getSummaries(param) {
        const { columns, data } = param;
        const sums = [];
        columns.forEach((column, index)=>{
          if (index===0){
            sums[index] = "合计";
          }else if (index >= 11){
            const values = data.map((item) => Number(item[column.property]));
            if (!values.every((value) => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                return prev+curr;
              },0)


            }
            console.log(column)
          }
        })
        return sums
      },
      deleteClick(index){
        this.checkTableData2.splice(index,1)
      },
      // 导入
      checkButton(index,row){
        this.importShow = true
      },
      tableRowClassName({row}) {
        if (row.remark==='价格异常') return 'ui-warning-row';
        else return '';
      },
      handleCurrentChange(val){
        console.log(val)
      },
      detailButton(id){
        this.detaiDialog=true
      },
      SubmitButton(id){
        this.$confirm('确认要提交审核吗！', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
        }).catch(() => {});
      },
      cancelButton(id){
        this.$confirm('确认要取消审核吗！', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
        }).catch(() => {});
      },
      deleteButton(id){
        this.$confirm('确认要删除对账单吗！', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
        }).catch(() => {});
      },

    },
  };
</script>



<style lang="scss" scoped>
  .bill-statement{
    width:100%;
    padding:20px 15px 0 25px;
    height: 100%;
    .exportButton{
      span{
        color: rgba(51, 136, 255, 1);
        text-decoration: underline;
        margin-right: 10px;
        &:hover{
          cursor: pointer;
        }
      }
    }

    .nav{
      width:100%;
      display: flex;
      align-items: center;
      overflow: hidden;
      .flex1{
        flex: 1;
      }
      .el-input{
        width: 150px;
      }
      .el-select{
        width: 150px;
      }
      ::v-deep {
        label.el-form-item__label {
          font-weight: 500;
          color: #101010;
        }
      }
    }
    ::v-deep .importBill{
      width: 100%;
      padding: 10px 0 20px 20px;
      .line{
        width: 12px;
        height: 32px;
        background-color: rgba(51, 84, 131, 100);
        margin-right: 10px;
      }
      .line +span{
        font-size: 16px;
        color: rgba(51, 84, 131, 100);
        font-weight: 600;
      }
      .el-table td, .el-table th{
        padding:0;
      }
      .el-button--mini{
        padding: 4px 4px;
      }

      .baseInfo{
        display: flex;
        flex-direction: column;
        &Title{
          display:flex;
          align-items:flex-end;
          p{
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }
        &Content{
          display:flex;
          flex-direction: column;
          justify-content: space-between;
          /*padding:20px 23px 0 23px;*/
          padding-right: 20px;
          margin-top: 20px;
          font-size: 14px;

          .el-table .ui-warning-row {
            background-color: #fef0f0!important;
          }
          .el-table--enable-row-hover .el-table__body tr.ui-warning-row:hover>td{
            background-color: #fef0f0!important;
          }
          .el-table .ui-warning-row .cell{
            color: red;
          }
          .cell{
            font-size: 10px;
            padding:0;
          }
          .iconError{
            font-size: 15px;
            i:hover{
              color: #00e1ff;
            }
          }
          .exportButton{
            span{
              color: rgba(51, 136, 255, 1);
              text-decoration: underline;
              margin-right: 10px;
              &:hover{
                cursor: pointer;
              }
            }
          }

        }
      }
      .operation{
        display: flex;
        flex-direction: column;
        margin-top: 20px;
        &Title{
          display:flex;
          align-items:flex-end;
          p{
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }
        .cell{
          font-size: 10px;
          padding:0;
        }
        &Table{
          width:100%;
          margin-top: 10px;
          padding-right: 20px;
        }
      }
    }
    ::v-deep .detail{
      .el-form-item__label{
        font-weight: 700;
      }
      .el-table td, .el-table th{
        padding:0;
      }
      .cell{
        font-size: 10px;
        padding:0;
      }
      .line{
        width: 12px;
        height: 32px;
        background-color: rgba(51, 84, 131, 100);
        margin-right: 10px;
      }
      .line +span{
        font-size: 16px;
        color: rgba(51, 84, 131, 100);
        font-weight: 600;
      }
      width: 100%;
      padding: 10px 0 20px 20px;
      .baseInfo{
        display: flex;
        flex-direction: column;
        &Title{
          display:flex;
          align-items:flex-end;
          p{
            font-weight: 700;
            font-size: 14px;
            color: rgba(249, 166, 6);
            margin-left: 10px;
          }
        }
        &Content{
          display:flex;
          flex-direction: column;
          justify-content: space-between;
          padding:20px 23px 0 23px;
          font-size: 14px;
          .center-f{
            display: flex;
          }
          .el-form-item{
            margin-bottom: 2px;
            .el-form-item__label{
              /*color: #060606;*/
            }
          }


        }
      }
      .operation{
        display: flex;
        flex-direction: column;
        &Title{
          display:flex;
          align-items:flex-end;
          p{
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }
        &Table{
          width:100%;
          margin-top: 10px;
          padding-right: 20px;
          &Nav{
            width:100%;
            display: flex;
            align-items: center;
            justify-content:flex-end;
            span{
              color: rgba(51, 136, 255, 1);
              text-decoration: underline;
              margin-right: 10px;
              font-weight: 400;
              &:hover{
                cursor: pointer;
              }
            }
          }
        }
      }
    }
    ::v-deep{

      .el-dialog__header {
        padding: 9px 20px 9px;
        background: #335483;
      }

      .el-dialog__title {
        line-height: 24px;
        font-size: 14px;
        color: #FFFFFF;
      }

      .el-dialog__headerbtn {
        top: 9px;
      }

      .el-dialog__headerbtn .el-dialog__close {
        color: #fff;
        font-size: 25px;
      }

      .el-dialog__body {
        padding: 0;
        overflow: auto;
        max-height: 75vh;
        color: #606266;
      }

    }

  }

</style>
